import { useState } from 'react';

interface BankLogoProps {
  bankName: string;
  logoUrl?: string | null;
  className?: string;
  fallbackClassName?: string;
}

export default function BankLogo({
  bankName,
  logoUrl,
  className,
  fallbackClassName,
}: BankLogoProps) {
  const [hasError, setHasError] = useState(false);

  const defaultClassName =
    className || 'w-6 h-6 rounded-sm object-contain bg-white border border-gray-100';
  const defaultFallback =
    fallbackClassName ||
    'w-6 h-6 rounded-sm bg-gray-100 border border-gray-200 flex items-center justify-center text-[10px] font-bold text-gray-500 shadow-sm';

  if (logoUrl && !hasError) {
    return (
      <img
        src={logoUrl}
        alt={bankName}
        className={defaultClassName}
        onError={() => setHasError(true)}
      />
    );
  }

  const initials = bankName ? bankName.substring(0, 2).toUpperCase() : 'BK';
  return <div className={defaultFallback}>{initials}</div>;
}
